"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _vue = _interopRequireDefault(require("vue"));

var _default = _vue.default.extend({
  data: function data() {
    return {
      sidebarOpen: false,
      // sidebarSection may be either '', 'user', 'settings', 'nicklist', 'about'
      sidebarSection: '',
      sidebarUser: null,
      activeComponent: null
    };
  },
  computed: {
    isDrawn: function isDrawn() {
      return this.sidebarOpen && this.$state.ui.app_width <= 769;
    },
    isClosed: function isClosed() {
      return !this.sidebarOpen;
    },
    isOpen: function isOpen() {
      return this.sidebarOpen && this.$state.ui.app_width > 769;
    }
  },
  created: function created() {
    var _this = this;

    this.listen(this.$state, 'sidebar.component', function (component) {
      _this.activeComponent = component;
      _this.sidebarOpen = !!component;
      _this.sidebarSection = '';
    }); // Allow forcing the sidebar open at startup

    this.$nextTick(function () {
      // nextTick is needed because app_width is 0 on created()
      var sidebarDefault = _this.$state.setting('sidebarDefault');

      if (sidebarDefault && _this.$state.ui.app_width > 769) {
        _this.sidebarSection = sidebarDefault;
        _this.sidebarOpen = true;
      }
    });
  },
  methods: {
    section: function section() {
      if (this.isClosed) {
        return '';
      }

      var section = this.sidebarSection;
      var isChannel = this.$state.getActiveBuffer().isChannel();

      if (section === 'settings' && isChannel) {
        return 'settings';
      } else if (section === 'user' && this.sidebarUser && isChannel) {
        return 'user';
      } else if (section === 'nicklist' && isChannel) {
        return 'nicklist';
      } else if (section === 'about') {
        return 'about';
      }

      return '';
    },
    close: function close() {
      this.activeComponent = null;
      this.sidebarOpen = false;
      this.sidebarSection = '';
      this.sidebarUser = null;
    },
    showUser: function showUser(user) {
      this.activeComponent = null;
      this.sidebarUser = user;
      this.sidebarOpen = true;
      this.sidebarSection = 'user';
    },
    showNicklist: function showNicklist() {
      this.activeComponent = null;
      this.sidebarOpen = true;
      this.sidebarSection = 'nicklist';
    },
    showBufferSettings: function showBufferSettings() {
      this.activeComponent = null;
      this.sidebarOpen = true;
      this.sidebarSection = 'settings';
    },
    showAbout: function showAbout() {
      this.activeComponent = null;
      this.sidebarOpen = true;
      this.sidebarSection = 'about';
    },
    toggleNicklist: function toggleNicklist() {
      this.sidebarSection === 'nicklist' ? this.close() : this.showNicklist();
    },
    toggleBufferSettings: function toggleBufferSettings() {
      this.sidebarSection === 'settings' ? this.close() : this.showBufferSettings();
    },
    toggleAbout: function toggleAbout() {
      this.sidebarSection === 'about' ? this.close() : this.showAbout();
    }
  }
});

exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SidebarState"]
window._kiwi_exports.components.SidebarState = exports.default ? exports.default : exports;
